import { styled } from '@mui/material';

import { forMobile } from '@/design-system';
import { colors } from '@/design-system/colors';

export const LayoutRoot = styled('div')({
  display: 'flex',
  minHeight: '100vh',
  width: '100%',
});

export const MainContent = styled('div')({
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  background: colors.background.canvas,
});

const PAGE_GUTTER = 24;
const PAGE_CONTENT_MAX_WIDTH = 1816;

export const MainWrapper = styled('main')({
  flexGrow: 1,
  padding: `16px ${PAGE_GUTTER}px ${PAGE_GUTTER}px`,
  background: colors.background.canvas,

  [forMobile]: {
    padding: '16px',
  },
});

export const PipelineMainWrapper = styled(MainWrapper)({
  display: 'flex',
  flexDirection: 'column',
  minHeight: 0,
});

export const ShellColumn = styled('div')({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  height: '100%',
});

export const PageBody = styled('div')({
  display: 'flex',
  flexGrow: 1,
  flexDirection: 'column',
  width: '100%',
  maxWidth: PAGE_CONTENT_MAX_WIDTH + PAGE_GUTTER * 2,
  margin: '0 auto',
});

export const ContentWrapper = styled('div')({
  display: 'flex',
  width: '100%',
  maxWidth: 1500,
  flexDirection: 'column',
  margin: '0 auto',
  height: '100%',
});
